import React, { memo } from 'react';
import styled from 'styled-components';
import { IForecastCard } from '../../common/types';
import { CommonContainerStyle } from '../styles';

type ConditionsDescriptionProps = Pick<IForecastCard, 'description'>;

export const ConditionsDescription = memo(({ description }: ConditionsDescriptionProps) => {
    return (
        <Container>
            { description }
        </Container>
    );
});

const Container = styled.div`
    ${CommonContainerStyle}
    flex-direction: row;
    margin-top: 13px;
    min-height: 40px;
    height: 50%;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    color: #666;
    justify-content: center;
    align-items: flex-start;
`;